<template>
    <div v-if="msg && msg.length && msg !== 'undefined' && !isBannerInvisibleCookie" class="msg-wrappper flex py-4 bg-green-light text-white justify-center items-center">
        <i class="fa fa-2x fa-bullhorn px-4" aria-hidden="true"></i>
        <span class="msg pr-6 cursor-default">{{ msg }}</span>
        <button @click="hideMsgHandler" class="pr-5 absolute right-0">
            <Cross></Cross>
        </button>
    </div>
</template>
<script>
import Cross from "@/components/icons/Cross.vue";
import * as Cookies from 'js-cookie'
export default {
    data () {
        return {
            msg: null
        }
    },
    mounted () {
     this.msg = window.config.VUE_APP_TOP_BANNER_MESSAGE
    },
    components: {
        Cross
    },
    methods: {
      hideMsgHandler () {
        const expirationDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000) // Expires in 1 day
        Cookies.set('fitclass_msgFlag', 'hidden', {
          expires: expirationDate,
          secure: true
        })
        this.msg = null;
      }
    },
    computed: {
      isBannerInvisibleCookie () {
        return Cookies.get('fitclass_msgFlag')
      }
    }
}
</script>

